import React from 'react';
import { Button } from 'flowbite-react';
import { HiArrowLeft, HiPlay } from 'react-icons/hi';
import { Shape } from '../Types';

interface SetupHeaderProps {
  onBack: () => void;
  onRun: (selectedImage: string, selectedShape: Shape, invertImage: boolean, maskSize: number, pathLength: number, numberOfPins: number) => void;
  selectedImage: string;
  selectedShape: Shape;
  invertImage: boolean;
  maskSize: number;
  pathLength: number;
  numberOfPins: number;
}

const SetupHeader: React.FC<SetupHeaderProps> = ({ 
  onBack, 
  onRun, 
  selectedImage, 
  selectedShape, 
  invertImage,
  maskSize,
  pathLength,
  numberOfPins
}) => {
  return (
    <>
      {/* Top Navigation */}
      <div className="flex justify-start items-center mb-8 max-w-4xl mx-auto">
        <Button 
          onClick={onBack}
          color="light"
          size="md"
        >
          <HiArrowLeft className="mr-2 h-5 w-5" />
          Back
        </Button>
      </div>

      <h1 className="text-3xl font-bold mb-6 text-gray-900">Setup Configuration</h1>
      <p className="text-lg mb-8 max-w-3xl mx-auto leading-relaxed text-gray-600">
        Configure your string art parameters and preview the setup before running the algorithm.
      </p>
      
      {/* Prominent Run Button */}
      <div className="mb-12">
        <Button
          onClick={() => onRun(selectedImage, selectedShape, invertImage, maskSize, pathLength, numberOfPins)}
          color="green"
          size="xl"
        >
          <HiPlay className="mr-3 h-7 w-7" />
          Run String Art Algorithm
        </Button>
      </div>
    </>
  );
};

export default SetupHeader;